// extracted by mini-css-extract-plugin
module.exports = {"root":"sessions-list_root__3ZXdk","pagination":"sessions-list_pagination__3_eXa"};